import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBagAdd2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShoppingBagAdd2"><Path fillRule="evenodd" clipRule="evenodd" d="M8.00155 6C8.00155 3.79086 9.79241 2 12.0015 2C14.2107 2 16.0015 3.79086 16.0015 6V7H18.3595L19.2825 13H15.0015V16H12.0015V22H3.33594L5.64363 7H8.00155V6ZM14.0015 7V6C14.0015 4.89543 13.1061 4 12.0015 4C10.897 4 10.0015 4.89543 10.0015 6V7H14.0015Z" fill="currentColor"/><Path d="M19.0015 18V15H17.0015V18H14.0015V20H17.0015V23H19.0015V20H22.0015V18H19.0015Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShoppingBagAdd2;
